<template>
  <div>
    <div class="search-header">
      <div class="box-title">我的收藏</div>
      <el-input v-model="dataForm.prodtName" style="width: 400px" placeholder="请输入">
        <el-button slot="append" icon="el-icon-search" type="primary" @click="getProductList">查询</el-button>
      </el-input>
    </div>
    <!-- <div class="filter-item">
      产品类型：<span
        v-for="item in prodtTypeList"
        :key="item.cd"
        class="item-type"
        :class="[dataForm.prodtType === item.cd ? 'active' : '']"
        @click="selectType(item)"
        >{{ item.nm }}</span
      >
    </div> -->
    <el-tabs v-model="activeName" @tab-click="handleTabClcik">
      <el-tab-pane label="产品收藏" name="1">
        <div class="flex-box">
          <ProductCard v-for="item in list" :key="item.id" :need-collect="true" class="ans-box" :item="item" @refresh="getProductList" />
        </div>
        <div v-if="list.length === 0" class="no-msg">暂无收藏</div>
        <el-pagination
          v-if="list.length"
          layout="prev, pager, next"
          :current-page="page.pageNo"
          :page-size="page.pageSize"
          :background="true"
          :total="total"
          @current-change="currentChangeHandle"
        />
      </el-tab-pane>
      <el-tab-pane label="政策收藏" name="2">
        <div style="width: 100%">
          <policy-item
            v-for="item in list1"
            :key="item.id"
            :status="status[item.timeType - 1]"
            :type="item.timeType === 1 ? 'info' : item.timeType === 2 ? 'primary' : 'info'"
            class="policy-item"
            @click.native="handlePolicyClick(item)"
          >
            <template slot="title">
              {{ item.title }}
            </template>
            <template slot="content">
              <div class="item">发文单位：{{ item.originOrg }}</div>
              <div class="item">政策类型：{{ item.policyType }}</div>
              <!-- <div class="item">申报时间：{{ item.applyTm }}</div> -->
              <div class="item">
                申报时间：{{ item.title === '青年人才租房补贴' ? '每月21日～月底' : item.applyTimeType !== 1 ? item.applyTm : '常态受理' }}
                {{ item.applyTimeType == 3 ? '(以具体通知为准)' : '' }}
              </div>
              <div class="item">政策内容：{{ filtersText(item.cont) }}</div>
              <img
                class="star-img"
                :src="item.isCollect ? require('@/assets/images/星星-active.png') : require('@/assets/images/星星.png')"
                alt=""
                @click.stop="collect(item)"
              />
            </template>
          </policy-item>
        </div>
        <div v-if="list1.length === 0" class="no-msg">暂无收藏</div>
        <el-pagination
          v-if="list1.length"
          layout="prev, pager, next"
          :current-page="page1.pageNo"
          :page-size="page1.pageSize"
          :background="true"
          :total="total1"
          @current-change="currentChangeHandle1"
        />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import ProductCard from '@/components/ProductCard'
import PolicyItem from '@/components/PolicyItem'
export default {
  components: { ProductCard, PolicyItem },
  data() {
    return {
      status: ['非申报期内', '申报期内', '非申报期内'],
      total: 0,
      total1: 0,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      page1: {
        pageNo: 1,
        pageSize: 10,
      },
      dataForm: {
        prodtType: '',
      },
      prodtTypeList: [],
      list: [],
      list1: [],
      activeName: '1',
    }
  },
  mounted() {
    this.getProductList()
    // this.getEnum('ZzmhProductEn$ProdtType', 'prodtTypeList')
  },
  methods: {
    collect(item) {
      let api = item.isCollect ? '/zzmh/in/api/policy/unCollect' : '/zzmh/in/api/policy/collect'
      this.$http({ method: 'get', url: `${api}?id=` + item.id })
        .then((res) => {
          this.$message.success('操作成功')
          this.getPolicyList()
        })
        .catch(() => {})
    },
    filtersText(str) {
      str = str.replace(/<\/?.+?>/g, '')
      str = str.replace(/&nbsp;/g, '')
      return str
    },
    getEnum(code, key) {
      this.$http({ method: 'get', url: `/general/enum/list?cls=${code}` }).then((res) => {
        this[key] = [{ nm: '全部', cd: '' }, ...res.data.list]
      })
    },
    selectType(item) {
      this.dataForm.prodtType = item.cd
      this.getProductList()
    },
    handleTabClcik(tab) {
      if (tab.name == '1') {
        this.getProductList()
      }
      if (tab.name == '2') {
        this.getPolicyList()
      }
    },
    currentChangeHandle(val) {
      this.page.pageNo = val
      this.getProductList()
    },
    getProductList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page.pageNo, this.page.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/in/product/selfCollectProduct?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then(
        (res) => {
          console.log(res)
          this.list = res.data.list.map((el) => {
            return {
              ...el,
              isCollect: true,
              prodtPictureUrl: (el.prodtPictureUrl || '').split(',')[0],
            }
          })
          this.total = res.page.total
        }
      )
    },
    currentChangeHandle1(val) {
      this.page1.pageNo = val
      this.getPolicyList()
    },
    getPolicyList() {
      let query = this.$query.new()
      this.$query.toF(query, this.dataForm)
      this.$query.toP(query, this.page1.pageNo, this.page1.pageSize)
      let params = {}
      this.$http({ method: 'get', url: '/zzmh/in/api/policy/selfCollect?query=' + encodeURIComponent(this.$query.toJsonStr(query)), params }).then((res) => {
        console.log(res)
        this.list1 = res.data.records.map((el) => {
          return {
            ...el.zzmhPolicyVo,
            timeType: el.timeType,
            isCollect: true,
          }
        })
        this.total1 = res.data.total
      })
    },
    handlePolicyClick(item) {
      let type = item.applicableObject == 1 ? 'person' : 'unit'
      this.$router.push({
        path: `/policy-detail/${item.id}?type=${type}`,
      })
    },
  },
}
</script>

<style lang="less" scoped>
@media screen {
  .no-msg {
    margin: 50px 0;
    text-align: center;
  }
  .search-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .box-title {
      font-family: PingFangSC-Semibold;
      font-size: 18px;
      color: #333333;
      letter-spacing: 0;
      font-weight: 600;
    }
  }
  .filter-item {
    font-size: 16px;
    padding-bottom: 20px;
  }
  .policy-item {
    border: 1px solid #e7e7e7;
    margin-bottom: 12px;
    width: 932px;
    cursor: pointer;
  }
  .flex-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }
  .ans-box {
    border: 1px solid #eee;
    margin-bottom: 20px;
    width: 225px;
    margin-right: 10px;
  }
  // .ans-box {
  //   background: #ffffff;
  //   box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.02);
  //   border-radius: 10px;
  //   padding: 12px 12px 0 12px;
  //   border: 1px solid #eee;
  //   width: 270px;
  //   margin-left: 10px;
  //   margin-bottom: 12px;
  //   .product-img {
  //     width: 100%;
  //     height: 120px;
  //   }
  //   .ans-box-btns {
  //     display: flex;
  //     font-size: 16px;
  //     justify-content: center;
  //     /deep/.el-button {
  //       width: 50px;
  //       &:not(:last-child) {
  //         &::after {
  //           content: '';
  //           display: inline-block;
  //           width: 2px;
  //           vertical-align: -1px;
  //           height: 14px;
  //           background: #ccc;
  //           margin-left: 15px;
  //         }
  //       }
  //     }
  //   }
  //   .ans-box-item {
  //     display: flex;
  //     justify-content: space-between;
  //     align-items: center;
  //     margin-bottom: 8px;
  //     .ans-box-title {
  //       font-family: PingFangSC-Medium;
  //       font-size: 16px;
  //       color: #333333;
  //       font-weight: 500;
  //     }
  //     .ans-box-title-sub {
  //       font-family: PingFangSC-Regular;
  //       font-size: 14px;
  //       color: #666666;
  //       letter-spacing: 0;
  //       font-weight: 400;
  //     }

  //     .ans-box-tag {
  //       background: #f6ffed;
  //       border: 1px solid rgba(217, 247, 190, 1);
  //       border-radius: 4px;
  //       font-family: PingFangSC-Regular;
  //       font-size: 14px;
  //       color: #52c41a;
  //       line-height: 22px;
  //       font-weight: 400;
  //       padding: 2px 4px;
  //     }
  //   }
  // }
  .item-type {
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    margin-right: 12px;
    cursor: pointer;
    &.active {
      color: #1b5bfa;
      font-family: PingFangSC-Semibold;
    }
  }
  .star-img {
    cursor: pointer;
    position: absolute;
    right: 120px;
    top: 20px;
    width: 28px;
  }
  @media (min-width: 769px) {
  }

  @media (max-width: 768px) {
  }
}
</style>
